// extracted by mini-css-extract-plugin
module.exports = {"arrow":"styles_arrow__3dBJm","tooltip":"styles_tooltip__2QDU2","tooltipBody":"styles_tooltipBody__2X-iC","fontIcon":"styles_fontIcon__1m15L"};